import LanguagesDataTable from "../../../components/dataTable/tables/LanguagesDataTable";

function LanguagesPageView() {
  return <LanguagesDataTable />;
}

export default LanguagesPageView;
